import ConfirmContestDealModal from "./ConfirmContestDealModal";
export default ConfirmContestDealModal;
